import { useTranslation } from "react-i18next";
import i18next from "src/i18n/config";

import { withMetaDescription } from "@navigation/utils/withMetaDescription";
import { CustomAlert } from "@shared/CustomAlert/CustomAlert";

import { useCurrentWorkspaceFeatures } from "./api/helpers";
import { SubscriptionSection } from "./components/SubscriptionSection/SubscriptionSection";
import { useWorkspacePageAccess } from "./hooks/useWorkspacePageAccess";
import { WorkspaceSubPageLayout } from "./WorkspaceSubPageLayout";

function WorkspaceSubscriptionPage() {
    const { t } = useTranslation(["pages"]);
    const { workspace, canViewSubscription } = useWorkspacePageAccess();
    const { data: workspaceFeatures = [], isLoading: isWorkspaceFeaturesLoading } = useCurrentWorkspaceFeatures();

    const subscription = workspace?.subscription;

    return (
        <WorkspaceSubPageLayout>
            {canViewSubscription && subscription ? (
                <SubscriptionSection
                    subscription={subscription}
                    features={workspaceFeatures}
                    isLoading={isWorkspaceFeaturesLoading}
                />
            ) : (
                <CustomAlert severity="info" title={t("pages:workspacePage.restricted.subscription.title")}>
                    {t("pages:workspacePage.restricted.subscription.description")}
                </CustomAlert>
            )}
        </WorkspaceSubPageLayout>
    );
}

export default withMetaDescription(WorkspaceSubscriptionPage, {
    title: i18next.t("pages:workspacePage.pages.subscription.metaTitle"),
    description: i18next.t("pages:workspacePage.pages.subscription.metaDescription"),
});
